import { render, staticRenderFns } from "./Businesses.vue?vue&type=template&id=64567183&scoped=true&lang=html&"
import script from "./Businesses.vue?vue&type=script&lang=js&"
export * from "./Businesses.vue?vue&type=script&lang=js&"
import style0 from "./Businesses.vue?vue&type=style&index=0&id=64567183&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64567183",
  null
  
)

export default component.exports